import { descriptorPropTypes } from "lib/common/descriptorcontrols/formhelpers";
import EntityProxy from "data/util/EntityProxy";
import React from "react";
import PropTypes from "prop-types";
import Kids from "lib/dataentry/lib/dataentryform/formitems/Kids";

export class Layoutsection extends React.Component {
    render() {
        const {
            descriptor,
            controlOnly
        } = this.props;
        const control = (
            <div key={descriptor.key}>
                <div id={descriptor.id}
                     className={`control-container-${descriptor.key} control-section-header`}
                     data-title={descriptor.label}>
                    <span
                        className="uic-sh-message-title">{descriptor.label}</span>
                </div>
                <Kids {...this.props} controlOnly={false} />
            </div>
        );
        return controlOnly
            ? control
            : <fieldset key={descriptor.key}>{control}</fieldset>;
    }
}

Layoutsection.propTypes = {
    descriptor: PropTypes.shape(descriptorPropTypes(null, false, true)),
    fluxContext: PropTypes.string.isRequired,
    activeRecord: PropTypes.instanceOf(EntityProxy).isRequired,
    controlOnly: PropTypes.bool
};

export default Layoutsection;



// WEBPACK FOOTER //
// ./app/lib/dataentry/lib/dataentryform/formitems/Layout/section.js